export default __webpack_public_path__ + "static/delete-a0eb38a4fac216c212bbe7d032ef685e.svg";